"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InsertLinkRounded_1 = __importDefault(require("@mui/icons-material/InsertLinkRounded"));
const LinkModal_1 = __importDefault(require("./LinkModal"));
const Button_1 = __importDefault(require("../../../ui/Button/Button"));
const react_2 = require("@remirror/react");
const Extensions_1 = require("../../../Extensions/Extensions");
const getShortcutSymbol_1 = require("../../../utils/getShortcutSymbol");
const LinkButton = ({ inPopover = false }) => {
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const { updateLink, updateAssetLink } = (0, react_2.useCommands)();
    const active = (0, react_2.useActive)();
    // If the image tool is active, disable the link tool as they shouldn't work at the same time
    const disabled = active.image() || active.codeBlock();
    const handleClick = () => {
        if (!showModal) {
            setShowModal(true);
        }
    };
    const handleShortcut = (0, react_1.useCallback)(() => {
        handleClick();
        // Prevent other key handlers being run
        return true;
    }, []);
    const handleSubmit = (data) => {
        if (data.linkType === Extensions_1.MarkName.AssetLink) {
            updateAssetLink({ text: data.text, attrs: data.assetLink, range: data.range });
        }
        else {
            updateLink({ text: data.text, attrs: data.link, range: data.range });
        }
        setShowModal(false);
    };
    // when Ctrl+K is pressed show the modal, only registered in the toolbar button instance to avoid the key press
    // being double handled.
    if (!inPopover) {
        // disable the shortcut if the button is disabled
        (0, react_2.useKeymap)('Mod-k', disabled ? () => true : handleShortcut);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { handleOnClick: handleClick, isActive: active.link() || active.assetLink(), icon: react_1.default.createElement(InsertLinkRounded_1.default, null), label: `Link (${(0, getShortcutSymbol_1.getShortcutSymbol)()}+K)`, isDisabled: disabled }),
        showModal && react_1.default.createElement(LinkModal_1.default, { onCancel: () => setShowModal(false), onSubmit: handleSubmit })));
};
exports.default = LinkButton;
